webpackJsonp([9],{

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return commonParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERR_OK; });
var commonParams = {
  g_tk: 1928093487,
  inCharset: 'utf-8',
  outCharset: 'utf-8',
  notice: 0,
  format: 'jsonp'
};

var options = {
  param: 'jsonpCallback'
};

var ERR_OK = 0;

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasClass */
/* harmony export (immutable) */ __webpack_exports__["c"] = addClass;
/* harmony export (immutable) */ __webpack_exports__["b"] = getData;
/* harmony export (immutable) */ __webpack_exports__["a"] = prefixStyle;
function hasClass(el, className) {
  var reg = new RegExp('(^|\\s)' + className + '(\\s|$)');
  return reg.test(el.className);
}

function addClass(el, className) {
  if (hasClass(el, className)) {
    return;
  }

  var newClass = el.className.split(' ');
  newClass.push(className);
  el.className = newClass.join(' ');
}

function getData(el, name, val) {
  var prefix = 'data-';
  if (val) {
    return el.setAttribute(prefix + name, val);
  }
  return el.getAttribute(prefix + name);
}

var elementStyle = document.createElement('div').style;

var vendor = function () {
  var transformNames = {
    webkit: 'webkitTransform',
    Moz: 'MozTransform',
    O: 'OTransform',
    ms: 'msTransform',
    standard: 'transform'
  };

  for (var key in transformNames) {
    if (elementStyle[transformNames[key]] !== undefined) {
      return key;
    }
  }

  return false;
}();

function prefixStyle(style) {
  if (vendor === false) {
    return false;
  }

  if (vendor === 'standard') {
    return style;
  }

  return vendor + style.charAt(0).toUpperCase() + style.substr(1);
}

/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createSong;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Song = function Song(_ref) {
  var id = _ref.id,
      mid = _ref.mid,
      singer = _ref.singer,
      name = _ref.name,
      album = _ref.album,
      duration = _ref.duration,
      image = _ref.image,
      url = _ref.url;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Song);

  this.id = id;
  this.mid = mid;
  this.singer = singer;
  this.name = name;
  this.album = album;
  this.duration = duration;
  this.image = image;
  this.url = url;
};

/* harmony default export */ __webpack_exports__["a"] = (Song);

function createSong(musicData) {
  return new Song({
    id: musicData.songid,
    mid: musicData.songmid,
    singer: filterSinger(musicData.singer),
    name: musicData.songname,
    album: musicData.albumname,
    duration: musicData.interval,
    image: 'https://y.gtimg.cn/music/photo_new/T002R300x300M000' + musicData.albummid + '.jpg?max_age=2592000',
    url: 'http://ws.stream.qqmusic.qq.com/' + musicData.songid + '.m4a?fromtag=46'
  });
}

function filterSinger(singer) {
  var ret = [];
  if (!singer) {
    return '';
  }
  singer.forEach(function (s) {
    ret.push(s.name);
  });
  return ret.join('/');
}

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = saveSearch;
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteSearch;
/* harmony export (immutable) */ __webpack_exports__["f"] = clearSearch;
/* harmony export (immutable) */ __webpack_exports__["a"] = loadSearch;
/* harmony export (immutable) */ __webpack_exports__["g"] = savePlay;
/* harmony export (immutable) */ __webpack_exports__["b"] = loadPlay;
/* harmony export (immutable) */ __webpack_exports__["h"] = saveFavorite;
/* harmony export (immutable) */ __webpack_exports__["i"] = deleteFavorite;
/* harmony export (immutable) */ __webpack_exports__["c"] = loadFavorite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_good_storage__ = __webpack_require__(497);


var SEARCH_KEY = '__search__';
var SEARCH_MAX_LEN = 15;

var PLAY_KEY = '__play__';
var PLAY_MAX_LEN = 200;

var FAVORITE_KEY = '__favorite__';
var FAVORITE_MAX_LEN = 200;

function insertArray(arr, val, compare, maxLen) {
  var index = arr.findIndex(compare);
  if (index === 0) {
    return;
  }
  if (index > 0) {
    arr.splice(index, 1);
  }
  arr.unshift(val);
  if (maxLen && arr.length > maxLen) {
    arr.pop();
  }
}

function deleteFromArray(arr, compare) {
  var index = arr.findIndex(compare);
  if (index > -1) {
    arr.splice(index, 1);
  }
}

function saveSearch(query) {
  var searches = __WEBPACK_IMPORTED_MODULE_0_good_storage__["a" /* default */].get(SEARCH_KEY, []);
  insertArray(searches, query, function (item) {
    return item === query;
  }, SEARCH_MAX_LEN);
  __WEBPACK_IMPORTED_MODULE_0_good_storage__["a" /* default */].set(SEARCH_KEY, searches);
  return searches;
}

function deleteSearch(query) {
  var searches = __WEBPACK_IMPORTED_MODULE_0_good_storage__["a" /* default */].get(SEARCH_KEY, []);
  deleteFromArray(searches, function (item) {
    return item === query;
  });
  __WEBPACK_IMPORTED_MODULE_0_good_storage__["a" /* default */].set(SEARCH_KEY, searches);
  return searches;
}

function clearSearch() {
  __WEBPACK_IMPORTED_MODULE_0_good_storage__["a" /* default */].remove(SEARCH_KEY);
  return [];
}

function loadSearch() {
  return __WEBPACK_IMPORTED_MODULE_0_good_storage__["a" /* default */].get(SEARCH_KEY, []);
}

function savePlay(song) {
  var songs = __WEBPACK_IMPORTED_MODULE_0_good_storage__["a" /* default */].get(PLAY_KEY, []);
  insertArray(songs, song, function (item) {
    return song.id === item.id;
  }, PLAY_MAX_LEN);
  __WEBPACK_IMPORTED_MODULE_0_good_storage__["a" /* default */].set(PLAY_KEY, songs);
  return songs;
}

function loadPlay() {
  return __WEBPACK_IMPORTED_MODULE_0_good_storage__["a" /* default */].get(PLAY_KEY, []);
}

function saveFavorite(song) {
  var songs = __WEBPACK_IMPORTED_MODULE_0_good_storage__["a" /* default */].get(FAVORITE_KEY, []);
  insertArray(songs, song, function (item) {
    return song.id === item.id;
  }, FAVORITE_MAX_LEN);
  __WEBPACK_IMPORTED_MODULE_0_good_storage__["a" /* default */].set(FAVORITE_KEY, songs);
  return songs;
}

function deleteFavorite(song) {
  var songs = __WEBPACK_IMPORTED_MODULE_0_good_storage__["a" /* default */].get(FAVORITE_KEY, []);
  deleteFromArray(songs, function (item) {
    return item.id === song.id;
  });
  __WEBPACK_IMPORTED_MODULE_0_good_storage__["a" /* default */].set(FAVORITE_KEY, songs);
  return songs;
}

function loadFavorite() {
  return __WEBPACK_IMPORTED_MODULE_0_good_storage__["a" /* default */].get(FAVORITE_KEY, []);
}

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_SINGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_PLAYING_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_FULL_SCREEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_PLAYLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_SEQUENCE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_PLAY_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_CURRENT_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_DISC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_TOP_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_SEARCH_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_PLAY_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_FAVORITE_LIST; });
var SET_SINGER = 'SET_SINGER';

var SET_PLAYING_STATE = 'SET_PLAYING_STATE';

var SET_FULL_SCREEN = 'SET_FULL_SCREEN';

var SET_PLAYLIST = 'SET_PLAYLIST';

var SET_SEQUENCE_LIST = 'SET_SEQUENCE_LIST';

var SET_PLAY_MODE = 'SET_PLAY_MODE';

var SET_CURRENT_INDEX = 'SET_CURRENT_INDEX';

var SET_DISC = 'SET_DISC';

var SET_TOP_LIST = 'SET_TOP_LIST';

var SET_SEARCH_HISTORY = 'SET_SEARCH_HISTORY';

var SET_PLAY_HISTORY = 'SET_PLAY_HISTORY';

var SET_FAVORITE_LIST = 'SET_FAVORITE_LIST';

/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(546);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var Recommend = function Recommend(resolve) {
  __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 553)).then(function (module) {
    resolve(module);
  });
};

var Singer = function Singer(resolve) {
  __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 556)).then(function (module) {
    resolve(module);
  });
};

var Rank = function Rank(resolve) {
  __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 552)).then(function (module) {
    resolve(module);
  });
};

var Search = function Search(resolve) {
  __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 554)).then(function (module) {
    resolve(module);
  });
};

var SingerDetail = function SingerDetail(resolve) {
  __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 555)).then(function (module) {
    resolve(module);
  });
};

var Disc = function Disc(resolve) {
  __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 551)).then(function (module) {
    resolve(module);
  });
};

var TopList = function TopList(resolve) {
  __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 557)).then(function (module) {
    resolve(module);
  });
};

var UserCenter = function UserCenter(resolve) {
  __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 558)).then(function (module) {
    resolve(module);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/recommend'
  }, {
    path: '/recommend',
    component: Recommend,
    children: [{
      path: ':id',
      component: Disc
    }]
  }, {
    path: '/singer',
    component: Singer,
    children: [{
      path: ':id',
      component: SingerDetail
    }]
  }, {
    path: '/rank',
    component: Rank,
    children: [{
      path: ':id',
      component: TopList
    }]
  }, {
    path: '/search',
    component: Search,
    children: [{
      path: ':id',
      component: SingerDetail
    }]
  }, {
    path: '/user',
    component: UserCenter
  }]
}));

/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  state: __WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* default */],
  strict: debug,
  plugins: debug ? [__WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger___default()()] : []
}));

/***/ }),

/***/ 191:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(542),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73b00972",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = jsonp;
/* unused harmony export param */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonp__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsonp__);



function jsonp(url, data, option) {
  url += (url.indexOf('?') < 0 ? '?' : '&') + param(data);

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_jsonp___default()(url, option, function (err, data) {
      if (!err) {
        resolve(data);
      } else {
        reject(err);
      }
    });
  });
}

function param(data) {
  var url = '';
  for (var k in data) {
    var value = data[k] !== undefined ? data[k] : '';
    url += '&' + k + '=' + encodeURIComponent(value);
  }
  return url ? url.substring(1) : '';
}

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(496)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(545),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-faf80856",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(481)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(530),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-215b2a49",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getHotKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = search;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_js_jsonp__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(127);




function getHotKey() {
  var url = 'https://c.y.qq.com/splcloud/fcgi-bin/gethotkey.fcg';

  var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__config__["b" /* commonParams */], {
    uin: 0,
    needNewCode: 1,
    platform: 'h5'
  });

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_common_js_jsonp__["a" /* default */])(url, data, __WEBPACK_IMPORTED_MODULE_2__config__["c" /* options */]);
}

function search(query, page, zhida, perpage) {
  var url = 'https://c.y.qq.com/soso/fcgi-bin/search_for_qq_cp';

  var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__config__["b" /* commonParams */], {
    w: query,
    p: page,
    perpage: perpage,
    n: perpage,
    catZhida: zhida ? 1 : 0,
    zhidaqu: 1,
    t: 0,
    flag: 1,
    ie: 'utf-8',
    sem: 1,
    aggr: 0,
    remoteplace: 'txt.mqq.all',
    uin: 0,
    needNewCode: 1,
    platform: 'h5'
  });

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_common_js_jsonp__["a" /* default */])(url, data, __WEBPACK_IMPORTED_MODULE_2__config__["c" /* options */]);
}

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Singer = function Singer(_ref) {
  var id = _ref.id,
      name = _ref.name;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Singer);

  this.id = id;
  this.name = name;
  this.avatar = "https://y.gtimg.cn/music/photo_new/T001R300x300M000" + id + ".jpg?max_age=2592000";
};

/* harmony default export */ __webpack_exports__["a"] = (Singer);

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(491)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(540),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-642d7edd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(531),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-273daa2f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(486)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(535),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4822341b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(484)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(533),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-387b8eba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(494)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(543),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9f63804a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(490)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(539),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63087aaa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fastclick__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_lazyload__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_stylus_index_styl__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_stylus_index_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_common_stylus_index_styl__);










__WEBPACK_IMPORTED_MODULE_4_fastclick___default.a.attach(document.body);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_lazyload___default.a, {
  loading: __webpack_require__(193)
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App___default.a);
  },
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]
});

/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectPlay", function() { return selectPlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "randomPlay", function() { return randomPlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "insertSong", function() { return insertSong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveSearchHistory", function() { return saveSearchHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteSearchHistory", function() { return deleteSearchHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearSearchHistory", function() { return clearSearchHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteSong", function() { return deleteSong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteSongList", function() { return deleteSongList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "savePlayHistory", function() { return savePlayHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveFavoriteList", function() { return saveFavoriteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteFavoriteList", function() { return deleteFavoriteList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_js_config__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_js_util__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_js_cache__ = __webpack_require__(132);





function findIndex(list, song) {
  return list.findIndex(function (item) {
    return item.id === song.id;
  });
}

var selectPlay = function selectPlay(_ref, _ref2) {
  var commit = _ref.commit,
      state = _ref.state;
  var list = _ref2.list,
      index = _ref2.index;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* SET_SEQUENCE_LIST */], list);
  if (state.mode === __WEBPACK_IMPORTED_MODULE_1_common_js_config__["a" /* playMode */].random) {
    var randomList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_common_js_util__["a" /* shuffle */])(list);
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SET_PLAYLIST */], randomList);
    index = findIndex(randomList, list[index]);
  } else {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SET_PLAYLIST */], list);
  }
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["g" /* SET_CURRENT_INDEX */], index);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_FULL_SCREEN */], true);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_PLAYING_STATE */], true);
};

var randomPlay = function randomPlay(_ref3, _ref4) {
  var commit = _ref3.commit;
  var list = _ref4.list;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["f" /* SET_PLAY_MODE */], __WEBPACK_IMPORTED_MODULE_1_common_js_config__["a" /* playMode */].random);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* SET_SEQUENCE_LIST */], list);
  var randomList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_common_js_util__["a" /* shuffle */])(list);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SET_PLAYLIST */], randomList);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["g" /* SET_CURRENT_INDEX */], 0);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_FULL_SCREEN */], true);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_PLAYING_STATE */], true);
};

var insertSong = function insertSong(_ref5, song) {
  var commit = _ref5.commit,
      state = _ref5.state;

  var playlist = state.playlist.slice();
  var sequenceList = state.sequenceList.slice();
  var currentIndex = state.currentIndex;

  var currentSong = playlist[currentIndex];

  var fpIndex = findIndex(playlist, song);

  currentIndex++;

  playlist.splice(currentIndex, 0, song);

  if (fpIndex > -1) {
    if (currentIndex > fpIndex) {
      playlist.splice(fpIndex, 1);
      currentIndex--;
    } else {
      playlist.splice(fpIndex + 1, 1);
    }
  }

  var currentSIndex = findIndex(sequenceList, currentSong) + 1;

  var fsIndex = findIndex(sequenceList, song);

  sequenceList.splice(currentSIndex, 0, song);

  if (fsIndex > -1) {
    if (currentSIndex > fsIndex) {
      sequenceList.splice(fsIndex, 1);
    } else {
      sequenceList.splice(fsIndex + 1, 1);
    }
  }

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SET_PLAYLIST */], playlist);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* SET_SEQUENCE_LIST */], sequenceList);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["g" /* SET_CURRENT_INDEX */], currentIndex);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_FULL_SCREEN */], true);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_PLAYING_STATE */], true);
};

var saveSearchHistory = function saveSearchHistory(_ref6, query) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["j" /* SET_SEARCH_HISTORY */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_common_js_cache__["d" /* saveSearch */])(query));
};

var deleteSearchHistory = function deleteSearchHistory(_ref7, query) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["j" /* SET_SEARCH_HISTORY */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_common_js_cache__["e" /* deleteSearch */])(query));
};

var clearSearchHistory = function clearSearchHistory(_ref8) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["j" /* SET_SEARCH_HISTORY */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_common_js_cache__["f" /* clearSearch */])());
};

var deleteSong = function deleteSong(_ref9, song) {
  var commit = _ref9.commit,
      state = _ref9.state;

  var playlist = state.playlist.slice();
  var sequenceList = state.sequenceList.slice();
  var currentIndex = state.currentIndex;
  var pIndex = findIndex(playlist, song);
  playlist.splice(pIndex, 1);
  var sIndex = findIndex(sequenceList, song);
  sequenceList.splice(sIndex, 1);
  if (currentIndex > pIndex || currentIndex === playlist.length) {
    currentIndex--;
  }

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SET_PLAYLIST */], playlist);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* SET_SEQUENCE_LIST */], sequenceList);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["g" /* SET_CURRENT_INDEX */], currentIndex);

  if (!playlist.length) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_PLAYING_STATE */], false);
  } else {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_PLAYING_STATE */], true);
  }
};

var deleteSongList = function deleteSongList(_ref10) {
  var commit = _ref10.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["g" /* SET_CURRENT_INDEX */], -1);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SET_PLAYLIST */], []);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* SET_SEQUENCE_LIST */], []);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_PLAYING_STATE */], false);
};

var savePlayHistory = function savePlayHistory(_ref11, song) {
  var commit = _ref11.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["k" /* SET_PLAY_HISTORY */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_common_js_cache__["g" /* savePlay */])(song));
};

var saveFavoriteList = function saveFavoriteList(_ref12, song) {
  var commit = _ref12.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["l" /* SET_FAVORITE_LIST */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_common_js_cache__["h" /* saveFavorite */])(song));
};

var deleteFavoriteList = function deleteFavoriteList(_ref13, song) {
  var commit = _ref13.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["l" /* SET_FAVORITE_LIST */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_common_js_cache__["i" /* deleteFavorite */])(song));
};

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "singer", function() { return singer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "playing", function() { return playing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fullScreen", function() { return fullScreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "playlist", function() { return playlist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sequenceList", function() { return sequenceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mode", function() { return mode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentIndex", function() { return currentIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentSong", function() { return currentSong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disc", function() { return disc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "topList", function() { return topList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchHistory", function() { return searchHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "playHistory", function() { return playHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "favoriteList", function() { return favoriteList; });
var singer = function singer(state) {
  return state.singer;
};

var playing = function playing(state) {
  return state.playing;
};

var fullScreen = function fullScreen(state) {
  return state.fullScreen;
};

var playlist = function playlist(state) {
  return state.playlist;
};

var sequenceList = function sequenceList(state) {
  return state.sequenceList;
};

var mode = function mode(state) {
  return state.mode;
};

var currentIndex = function currentIndex(state) {
  return state.currentIndex;
};

var currentSong = function currentSong(state) {
  return state.playlist[state.currentIndex] || {};
};

var disc = function disc(state) {
  return state.disc;
};

var topList = function topList(state) {
  return state.topList;
};

var searchHistory = function searchHistory(state) {
  return state.searchHistory;
};

var playHistory = function playHistory(state) {
  return state.playHistory;
};

var favoriteList = function favoriteList(state) {
  return state.favoriteList;
};

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(133);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SET_SINGER */], function (state, singer) {
  state.singer = singer;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SET_PLAYING_STATE */], function (state, flag) {
  state.playing = flag;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* SET_FULL_SCREEN */], function (state, flag) {
  state.fullScreen = flag;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* SET_PLAYLIST */], function (state, list) {
  state.playlist = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* SET_SEQUENCE_LIST */], function (state, list) {
  state.sequenceList = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* SET_PLAY_MODE */], function (state, mode) {
  state.mode = mode;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* SET_CURRENT_INDEX */], function (state, index) {
  state.currentIndex = index;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* SET_DISC */], function (state, disc) {
  state.disc = disc;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_TOP_LIST */], function (state, topList) {
  state.topList = topList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* SET_SEARCH_HISTORY */], function (state, history) {
  state.searchHistory = history;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* SET_PLAY_HISTORY */], function (state, history) {
  state.playHistory = history;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* SET_FAVORITE_LIST */], function (state, list) {
  state.favoriteList = list;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_config__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_js_cache__ = __webpack_require__(132);



var state = {
  singer: {},
  playing: false,
  fullScreen: false,
  playlist: [],
  sequenceList: [],
  mode: __WEBPACK_IMPORTED_MODULE_0_common_js_config__["a" /* playMode */].sequence,
  currentIndex: -1,
  disc: {},
  topList: {},
  searchHistory: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_common_js_cache__["a" /* loadSearch */])(),
  playHistory: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_common_js_cache__["b" /* loadPlay */])(),
  favoriteList: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_common_js_cache__["c" /* loadFavorite */])()
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_m_header_m_header__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_m_header_m_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_m_header_m_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_tab_tab__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_tab_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_tab_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_player_player__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_player_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_player_player__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MHeader: __WEBPACK_IMPORTED_MODULE_0_components_m_header_m_header___default.a,
    Tab: __WEBPACK_IMPORTED_MODULE_1_components_tab_tab___default.a,
    Player: __WEBPACK_IMPORTED_MODULE_2_components_player_player___default.a
  }
});

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    text: {
      type: String,
      default: ''
    },
    confirmBtnText: {
      type: String,
      default: '确定'
    },
    cancelBtnText: {
      type: String,
      default: '取消'
    }
  },
  data: function data() {
    return {
      showFlag: false
    };
  },

  methods: {
    show: function show() {
      this.showFlag = true;
    },
    hide: function hide() {
      this.showFlag = false;
    },
    cancel: function cancel() {
      this.hide();
      this.$emit('cancel');
    },
    confirm: function confirm() {
      this.hide();
      this.$emit('confirm');
    }
  }
});

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String,
      default: '正在载入...'
    }
  }
});

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_dom__ = __webpack_require__(129);




var progressBtnWidth = 16;
var transform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_dom__["a" /* prefixStyle */])('transform');

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    percent: {
      type: Number,
      default: 0
    }
  },
  created: function created() {
    this.touch = {};
  },

  methods: {
    progressTouchStart: function progressTouchStart(e) {
      this.touch.initiated = true;
      this.touch.startX = e.touches[0].pageX;
      this.touch.left = this.$refs.progress.clientWidth;
    },
    progressTouchMove: function progressTouchMove(e) {
      if (!this.touch.initiated) {
        return;
      }
      var deltaX = e.touches[0].pageX - this.touch.startX;
      var offsetWidth = Math.min(this.$refs.progressBar.clientWidth - progressBtnWidth, Math.max(0, this.touch.left + deltaX));
      this._offset(offsetWidth);
    },
    progressTouchEnd: function progressTouchEnd() {
      this.touch.initiated = false;
      this._triggerPercent();
    },
    progressClick: function progressClick(e) {
      var rect = this.$refs.progressBar.getBoundingClientRect();
      var offsetWidth = e.pageX - rect.left;
      this._offset(offsetWidth);

      this._triggerPercent();
    },
    _triggerPercent: function _triggerPercent() {
      var barWidth = this.$refs.progressBar.clientWidth - progressBtnWidth;
      var percent = this.$refs.progress.clientWidth / barWidth;
      this.$emit('percentChange', percent);
    },
    _offset: function _offset(offsetWidth) {
      this.$refs.progress.style.width = offsetWidth + 'px';
      this.$refs.progressBtn.style[transform] = 'translate3d(' + offsetWidth + 'px,0,0)';
    }
  },
  watch: {
    percent: function percent(newPercent) {
      if (newPercent >= 0 && !this.touch.initiated) {
        var barWidth = this.$refs.progressBar.clientWidth - progressBtnWidth;
        var offsetWidth = newPercent * barWidth;
        this._offset(offsetWidth);
      }
    }
  }
});

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    radius: {
      type: Number,
      default: 100
    },
    percent: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      dashArray: Math.PI * 100
    };
  },

  computed: {
    dashOffset: function dashOffset() {
      return (1 - this.percent) * this.dashArray;
    }
  }
});

/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_scroll__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_better_scroll__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    probeType: {
      type: Number,
      default: 1
    },
    click: {
      type: Boolean,
      default: true
    },
    listenScroll: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: null
    },
    pullup: {
      type: Boolean,
      default: false
    },
    beforeScroll: {
      type: Boolean,
      default: false
    },
    refreshDelay: {
      type: Number,
      default: 20
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this._initScroll();
    }, 20);
  },

  methods: {
    _initScroll: function _initScroll() {
      var _this2 = this;

      if (!this.$refs.wrapper) {
        return;
      }
      this.scroll = new __WEBPACK_IMPORTED_MODULE_0_better_scroll___default.a(this.$refs.wrapper, {
        probeType: this.probeType,
        click: this.click
      });

      if (this.listenScroll) {
        var me = this;
        this.scroll.on('scroll', function (pos) {
          me.$emit('scroll', pos);
        });
      }

      if (this.pullup) {
        this.scroll.on('scrollEnd', function () {
          if (_this2.scroll.y <= _this2.scroll.maxScrollY + 50) {
            _this2.$emit('scrollToEnd');
          }
        });
      }

      if (this.beforeScroll) {
        this.scroll.on('beforeScrollStart', function () {
          _this2.$emit('beforeScroll');
        });
      }
    },
    disable: function disable() {
      this.scroll && this.scroll.disable();
    },
    enable: function enable() {
      this.scroll && this.scroll.enable();
    },
    refresh: function refresh() {
      this.scroll && this.scroll.refresh();
    },
    scrollTo: function scrollTo() {
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
    },
    scrollToElement: function scrollToElement() {
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
    }
  },
  watch: {
    data: function data() {
      var _this3 = this;

      setTimeout(function () {
        _this3.refresh();
      }, this.refreshDelay);
    }
  }
});

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_util__ = __webpack_require__(88);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    placeholder: {
      type: String,
      default: '搜索歌曲、歌手'
    }
  },
  data: function data() {
    return {
      query: ''
    };
  },

  methods: {
    clear: function clear() {
      this.query = '';
    },
    setQuery: function setQuery(query) {
      this.query = query;
    },
    blur: function blur() {
      this.$refs.query.blur();
    }
  },
  created: function created() {
    var _this = this;

    this.$watch('query', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util__["b" /* debounce */])(function (newQuery) {
      _this.$emit('query', newQuery);
    }, 200));
  }
});

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    searches: {
      type: Array,
      default: []
    }
  },
  methods: {
    selectItem: function selectItem(item) {
      this.$emit('select', item);
    },
    deleteOne: function deleteOne(item) {
      this.$emit('delete', item);
    }
  }
});

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    songs: {
      type: Array,
      default: []
    },
    rank: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectItem: function selectItem(item, index) {
      this.$emit('select', item, index);
    },
    getDesc: function getDesc(song) {
      return song.singer + '\xB7' + song.album;
    },
    getRankCls: function getRankCls(index) {
      if (index <= 2) {
        return 'icon icon' + index;
      } else {
        return 'text';
      }
    },
    getRankText: function getRankText(index) {
      if (index > 2) {
        return index + 1;
      }
    }
  }
});

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    switches: {
      type: Array,
      default: []
    },
    currentIndex: {
      type: Number,
      default: 0
    }
  },
  methods: {
    switchItem: function switchItem(index) {
      this.$emit('switch', index);
    }
  }
});

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    delay: {
      type: Number,
      default: 2000
    }
  },
  data: function data() {
    return {
      showFlag: false
    };
  },

  methods: {
    show: function show() {
      var _this = this;

      this.showFlag = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this.hide();
      }, this.delay);
    },
    hide: function hide() {
      this.showFlag = false;
    }
  }
});

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base_search_box_search_box__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base_search_box_search_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_base_search_box_search_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_base_song_list_song_list__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_base_song_list_song_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_base_song_list_song_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_base_search_list_search_list__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_base_search_list_search_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_base_search_list_search_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_scroll_scroll__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_base_scroll_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_base_switches_switches__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_base_switches_switches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_base_switches_switches__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_base_top_tip_top_tip__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_base_top_tip_top_tip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_base_top_tip_top_tip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_suggest_suggest__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_suggest_suggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_suggest_suggest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_common_js_mixin__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_common_js_song__ = __webpack_require__(130);














/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8_common_js_mixin__["b" /* searchMixin */]],
  data: function data() {
    return {
      showFlag: false,
      showSinger: false,
      currentIndex: 0,
      songs: [],
      switches: [{
        name: '最近播放'
      }, {
        name: '搜索历史'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])(['playHistory'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    show: function show() {
      var _this = this;

      this.showFlag = true;
      setTimeout(function () {
        if (_this.currentIndex === 0) {
          _this.$refs.songList.refresh();
        } else {
          _this.$refs.searchList.refresh();
        }
      }, 20);
    },
    hide: function hide() {
      this.showFlag = false;
    },
    selectSong: function selectSong(song, index) {
      if (index !== 0) {
        this.insertSong(new __WEBPACK_IMPORTED_MODULE_10_common_js_song__["a" /* default */](song));
        this.$refs.topTip.show();
      }
    },
    selectSuggest: function selectSuggest() {
      this.$refs.topTip.show();
      this.saveSearch();
    },
    switchItem: function switchItem(index) {
      this.currentIndex = index;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])(['insertSong'])),
  components: {
    SearchBox: __WEBPACK_IMPORTED_MODULE_1_base_search_box_search_box___default.a,
    SongList: __WEBPACK_IMPORTED_MODULE_2_base_song_list_song_list___default.a,
    SearchList: __WEBPACK_IMPORTED_MODULE_3_base_search_list_search_list___default.a,
    Scroll: __WEBPACK_IMPORTED_MODULE_4_base_scroll_scroll___default.a,
    Switches: __WEBPACK_IMPORTED_MODULE_5_base_switches_switches___default.a,
    TopTip: __WEBPACK_IMPORTED_MODULE_6_base_top_tip_top_tip___default.a,
    Suggest: __WEBPACK_IMPORTED_MODULE_7_components_suggest_suggest___default.a
  }
});

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_js_dom__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_progress_bar_progress_bar__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_progress_bar_progress_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_base_progress_bar_progress_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_base_progress_circle_progress_circle__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_base_progress_circle_progress_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_base_progress_circle_progress_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_js_config__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lyric_parser__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lyric_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lyric_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_base_scroll_scroll__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_base_scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_base_scroll_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_common_js_mixin__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_playlist_playlist__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_playlist_playlist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_playlist_playlist__);














var transform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_common_js_dom__["a" /* prefixStyle */])('transform');
var transitionDuration = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_common_js_dom__["a" /* prefixStyle */])('transitionDuration');

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9_common_js_mixin__["c" /* playerMixin */]],
  data: function data() {
    return {
      songReady: false,
      currentTime: 0,
      radius: 32,
      currentLyric: null,
      currentLineNum: 0,
      currentShow: 'cd',
      playingLyric: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    cdCls: function cdCls() {
      return this.playing ? 'play' : 'play pause';
    },
    playIcon: function playIcon() {
      return this.playing ? 'icon-pause' : 'icon-play';
    },
    miniIcon: function miniIcon() {
      return this.playing ? 'icon-pause-mini' : 'icon-play-mini';
    },
    disableCls: function disableCls() {
      return this.songReady ? '' : 'disable';
    },
    percent: function percent() {
      return this.currentTime / this.currentSong.duration;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['currentIndex', 'fullScreen', 'playing'])),
  created: function created() {
    this.touch = {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    back: function back() {
      this.setFullScreen(false);
    },
    open: function open() {
      this.setFullScreen(true);
    },
    enter: function enter(el, done) {
      var _getPosAndScale = this._getPosAndScale(),
          x = _getPosAndScale.x,
          y = _getPosAndScale.y,
          scale = _getPosAndScale.scale;

      var animation = {
        0: {
          transform: 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + scale + ')'
        },
        60: {
          transform: 'translate3d(0,0,0) scale(1.1)'
        },
        100: {
          transform: 'translate3d(0,0,0) scale(1)'
        }
      };

      __WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation___default.a.registerAnimation({
        name: 'move',
        animation: animation,
        presets: {
          duration: 400,
          easing: 'linear'
        }
      });

      __WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation___default.a.runAnimation(this.$refs.cdWrapper, 'move', done);
    },
    afterEnter: function afterEnter() {
      __WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation___default.a.unregisterAnimation('move');
      this.$refs.cdWrapper.style.animation = '';
    },
    leave: function leave(el, done) {
      this.$refs.cdWrapper.style.transition = 'all 0.4s';

      var _getPosAndScale2 = this._getPosAndScale(),
          x = _getPosAndScale2.x,
          y = _getPosAndScale2.y,
          scale = _getPosAndScale2.scale;

      this.$refs.cdWrapper.style[transform] = 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + scale + ')';
      this.$refs.cdWrapper.addEventListener('transitionend', done);
    },
    afterLeave: function afterLeave() {
      this.$refs.cdWrapper.style.transition = '';
      this.$refs.cdWrapper.style[transform] = '';
    },
    togglePlaying: function togglePlaying() {
      if (!this.songReady) {
        return;
      }
      this.setPlayingState(!this.playing);
      if (this.currentLyric) {
        this.currentLyric.togglePlay();
      }
    },
    end: function end() {
      if (this.mode === __WEBPACK_IMPORTED_MODULE_6_common_js_config__["a" /* playMode */].loop) {
        this.loop();
      } else {
        this.next();
      }
    },
    loop: function loop() {
      this.$refs.audio.currentTime = 0;
      this.$refs.audio.play();
      this.setPlayingState(true);
      if (this.currentLyric) {
        this.currentLyric.seek(0);
      }
    },
    next: function next() {
      if (!this.songReady) {
        return;
      }
      if (this.playlist.length === 1) {
        this.loop();
        return;
      } else {
        var index = this.currentIndex + 1;
        if (index === this.playlist.length) {
          index = 0;
        }
        this.setCurrentIndex(index);
        if (!this.playing) {
          this.togglePlaying();
        }
      }
      this.songReady = false;
    },
    prev: function prev() {
      if (!this.songReady) {
        return;
      }
      if (this.playlist.length === 1) {
        this.loop();
        return;
      } else {
        var index = this.currentIndex - 1;
        if (index === -1) {
          index = this.playlist.length - 1;
        }
        this.setCurrentIndex(index);
        if (!this.playing) {
          this.togglePlaying();
        }
      }
      this.songReady = false;
    },
    ready: function ready() {
      this.songReady = true;
      this.savePlayHistory(this.currentSong);
    },
    error: function error() {
      this.songReady = true;
    },
    updateTime: function updateTime(e) {
      this.currentTime = e.target.currentTime;
    },
    format: function format(interval) {
      interval = interval | 0;
      var minute = interval / 60 | 0;
      var second = this._pad(interval % 60);
      return minute + ':' + second;
    },
    onProgressBarChange: function onProgressBarChange(percent) {
      var currentTime = this.currentSong.duration * percent;
      this.$refs.audio.currentTime = currentTime;
      if (!this.playing) {
        this.togglePlaying();
      }
      if (this.currentLyric) {
        this.currentLyric.seek(currentTime * 1000);
      }
    },
    getLyric: function getLyric() {
      var _this = this;

      this.currentSong.getLyric().then(function (lyric) {
        if (_this.currentSong.lyric !== lyric) {
          return;
        }
        _this.currentLyric = new __WEBPACK_IMPORTED_MODULE_7_lyric_parser___default.a(lyric, _this.handleLyric);
        if (_this.playing) {
          _this.currentLyric.play();
        }
      }).catch(function () {
        _this.currentLyric = null;
        _this.playingLyric = '';
        _this.currentLineNum = 0;
      });
    },
    handleLyric: function handleLyric(_ref) {
      var lineNum = _ref.lineNum,
          txt = _ref.txt;

      this.currentLineNum = lineNum;
      if (lineNum > 5) {
        var lineEl = this.$refs.lyricLine[lineNum - 5];
        this.$refs.lyricList.scrollToElement(lineEl, 1000);
      } else {
        this.$refs.lyricList.scrollTo(0, 0, 1000);
      }
      this.playingLyric = txt;
    },
    showPlaylist: function showPlaylist() {
      this.$refs.playlist.show();
    },
    middleTouchStart: function middleTouchStart(e) {
      this.touch.initiated = true;

      this.touch.moved = false;
      var touch = e.touches[0];
      this.touch.startX = touch.pageX;
      this.touch.startY = touch.pageY;
    },
    middleTouchMove: function middleTouchMove(e) {
      if (!this.touch.initiated) {
        return;
      }
      var touch = e.touches[0];
      var deltaX = touch.pageX - this.touch.startX;
      var deltaY = touch.pageY - this.touch.startY;
      if (Math.abs(deltaY) > Math.abs(deltaX)) {
        return;
      }
      if (!this.touch.moved) {
        this.touch.moved = true;
      }
      var left = this.currentShow === 'cd' ? 0 : -window.innerWidth;
      var offsetWidth = Math.min(0, Math.max(-window.innerWidth, left + deltaX));
      this.touch.percent = Math.abs(offsetWidth / window.innerWidth);
      this.$refs.lyricList.$el.style[transform] = 'translate3d(' + offsetWidth + 'px,0,0)';
      this.$refs.lyricList.$el.style[transitionDuration] = 0;
      this.$refs.middleL.style.opacity = 1 - this.touch.percent;
      this.$refs.middleL.style[transitionDuration] = 0;
    },
    middleTouchEnd: function middleTouchEnd() {
      if (!this.touch.moved) {
        return;
      }
      var offsetWidth = void 0;
      var opacity = void 0;
      if (this.currentShow === 'cd') {
        if (this.touch.percent > 0.1) {
          offsetWidth = -window.innerWidth;
          opacity = 0;
          this.currentShow = 'lyric';
        } else {
          offsetWidth = 0;
          opacity = 1;
        }
      } else {
        if (this.touch.percent < 0.9) {
          offsetWidth = 0;
          this.currentShow = 'cd';
          opacity = 1;
        } else {
          offsetWidth = -window.innerWidth;
          opacity = 0;
        }
      }
      var time = 300;
      this.$refs.lyricList.$el.style[transform] = 'translate3d(' + offsetWidth + 'px,0,0)';
      this.$refs.lyricList.$el.style[transitionDuration] = time + 'ms';
      this.$refs.middleL.style.opacity = opacity;
      this.$refs.middleL.style[transitionDuration] = time + 'ms';
      this.touch.initiated = false;
    },
    _pad: function _pad(num) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

      var len = num.toString().length;
      while (len < n) {
        num = '0' + num;
        len++;
      }
      return num;
    },
    _getPosAndScale: function _getPosAndScale() {
      var targetWidth = 40;
      var paddingLeft = 40;
      var paddingBottom = 30;
      var paddingTop = 80;
      var width = window.innerWidth * 0.8;
      var scale = targetWidth / width;
      var x = -(window.innerWidth / 2 - paddingLeft);
      var y = window.innerHeight - paddingTop - width / 2 - paddingBottom;
      return {
        x: x,
        y: y,
        scale: scale
      };
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])({
    setFullScreen: 'SET_FULL_SCREEN'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['savePlayHistory'])),
  watch: {
    currentSong: function currentSong(newSong, oldSong) {
      var _this2 = this;

      if (!newSong.id) {
        return;
      }
      if (newSong.id === oldSong.id) {
        return;
      }
      if (this.currentLyric) {
        this.currentLyric.stop();
        this.currentTime = 0;
        this.playingLyric = '';
        this.currentLineNum = 0;
      }
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this2.$refs.audio.play();
        _this2.getLyric();
      }, 1000);
    },
    playing: function playing(newPlaying) {
      var audio = this.$refs.audio;
      this.$nextTick(function () {
        newPlaying ? audio.play() : audio.pause();
      });
    },
    fullScreen: function fullScreen(newVal) {
      var _this3 = this;

      if (newVal) {
        setTimeout(function () {
          _this3.$refs.lyricList.refresh();
        }, 20);
      }
    }
  },
  components: {
    ProgressBar: __WEBPACK_IMPORTED_MODULE_4_base_progress_bar_progress_bar___default.a,
    ProgressCircle: __WEBPACK_IMPORTED_MODULE_5_base_progress_circle_progress_circle___default.a,
    Scroll: __WEBPACK_IMPORTED_MODULE_8_base_scroll_scroll___default.a,
    Playlist: __WEBPACK_IMPORTED_MODULE_10_components_playlist_playlist___default.a
  }
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_js_config__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_base_scroll_scroll__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_base_scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_base_scroll_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_confirm_confirm__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_confirm_confirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_base_confirm_confirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_add_song_add_song__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_add_song_add_song___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_add_song_add_song__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_js_mixin__ = __webpack_require__(87);










/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6_common_js_mixin__["c" /* playerMixin */]],
  data: function data() {
    return {
      showFlag: false,
      refreshDelay: 120
    };
  },

  computed: {
    modeText: function modeText() {
      return this.mode === __WEBPACK_IMPORTED_MODULE_2_common_js_config__["a" /* playMode */].sequence ? '顺序播放' : this.mode === __WEBPACK_IMPORTED_MODULE_2_common_js_config__["a" /* playMode */].random ? '随机播放' : '单曲循环';
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    show: function show() {
      var _this = this;

      this.showFlag = true;
      setTimeout(function () {
        _this.$refs.listContent.refresh();
        _this.scrollToCurrent(_this.currentSong);
      }, 20);
    },
    hide: function hide() {
      this.showFlag = false;
    },
    showConfirm: function showConfirm() {
      this.$refs.confirm.show();
    },
    confirmClear: function confirmClear() {
      this.deleteSongList();
      this.hide();
    },
    getCurrentIcon: function getCurrentIcon(item) {
      if (this.currentSong.id === item.id) {
        return 'icon-play';
      }
      return '';
    },
    selectItem: function selectItem(item, index) {
      if (this.mode === __WEBPACK_IMPORTED_MODULE_2_common_js_config__["a" /* playMode */].random) {
        index = this.playlist.findIndex(function (song) {
          return song.id === item.id;
        });
      }
      this.setCurrentIndex(index);
      this.setPlayingState(true);
    },
    scrollToCurrent: function scrollToCurrent(current) {
      var index = this.sequenceList.findIndex(function (song) {
        return current.id === song.id;
      });
      this.$refs.listContent.scrollToElement(this.$refs.list.$el.children[index], 300);
    },
    deleteOne: function deleteOne(item) {
      this.deleteSong(item);
      if (!this.playlist.length) {
        this.hide();
      }
    },
    addSong: function addSong() {
      this.$refs.addSong.show();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['deleteSong', 'deleteSongList'])),
  watch: {
    currentSong: function currentSong(newSong, oldSong) {
      var _this2 = this;

      if (!this.showFlag || newSong.id === oldSong.id) {
        return;
      }
      setTimeout(function () {
        _this2.scrollToCurrent(newSong);
      }, 20);
    }
  },
  components: {
    Scroll: __WEBPACK_IMPORTED_MODULE_3_base_scroll_scroll___default.a,
    Confirm: __WEBPACK_IMPORTED_MODULE_4_base_confirm_confirm___default.a,
    AddSong: __WEBPACK_IMPORTED_MODULE_5_components_add_song_add_song___default.a
  }
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base_scroll_scroll__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base_scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_base_scroll_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_base_loading_loading__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_base_loading_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_base_loading_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_base_no_result_no_result__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_base_no_result_no_result___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_base_no_result_no_result__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api_search__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_api_config__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_js_song__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_common_js_singer__ = __webpack_require__(201);












var TYPE_SINGER = 'singer';
var perpage = 20;

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    showSinger: {
      type: Boolean,
      default: true
    },
    query: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      page: 1,
      pullup: true,
      beforeScroll: true,
      hasMore: true,
      result: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    refresh: function refresh() {
      this.$refs.suggest.refresh();
    },
    search: function search() {
      var _this = this;

      this.page = 1;
      this.hasMore = true;
      this.$refs.suggest.scrollTo(0, 0);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_api_search__["b" /* search */])(this.query, this.page, this.showSinger, perpage).then(function (res) {
        if (res.code === __WEBPACK_IMPORTED_MODULE_5_api_config__["a" /* ERR_OK */]) {
          _this.result = _this._genResult(res.data);
          _this._checkMore(res.data);
        }
      });
    },
    searchMore: function searchMore() {
      var _this2 = this;

      if (!this.hasMore) {
        return;
      }
      this.page++;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_api_search__["b" /* search */])(this.query, this.page, this.showSinger, perpage).then(function (res) {
        if (res.code === __WEBPACK_IMPORTED_MODULE_5_api_config__["a" /* ERR_OK */]) {
          _this2.result = _this2.result.concat(_this2._genResult(res.data));
          _this2._checkMore(res.data);
        }
      });
    },
    listScroll: function listScroll() {
      this.$emit('listScroll');
    },
    selectItem: function selectItem(item) {
      if (item.type === TYPE_SINGER) {
        var singer = new __WEBPACK_IMPORTED_MODULE_8_common_js_singer__["a" /* default */]({
          id: item.singermid,
          name: item.singername
        });
        this.$router.push({
          path: '/search/' + singer.id
        });
        this.setSinger(singer);
      } else {
        this.insertSong(item);
      }
      this.$emit('select', item);
    },
    getDisplayName: function getDisplayName(item) {
      if (item.type === TYPE_SINGER) {
        return item.singername;
      } else {
        return item.name + '-' + item.singer;
      }
    },
    getIconCls: function getIconCls(item) {
      if (item.type === TYPE_SINGER) {
        return 'icon-mine';
      } else {
        return 'icon-music';
      }
    },
    _genResult: function _genResult(data) {
      var ret = [];
      if (data.zhida && data.zhida.singerid) {
        ret.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data.zhida, { type: TYPE_SINGER }));
      }
      if (data.song) {
        ret = ret.concat(this._normalizeSongs(data.song.list));
      }
      return ret;
    },
    _normalizeSongs: function _normalizeSongs(list) {
      var ret = [];
      list.forEach(function (musicData) {
        if (musicData.songid && musicData.albummid) {
          ret.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_common_js_song__["b" /* createSong */])(musicData));
        }
      });
      return ret;
    },
    _checkMore: function _checkMore(data) {
      var song = data.song;
      if (!song.list.length || song.curnum + song.curpage * perpage > song.totalnum) {
        this.hasMore = false;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapMutations */])({
    setSinger: 'SET_SINGER'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(['insertSong'])),
  watch: {
    query: function query(newQuery) {
      this.search(newQuery);
    }
  },
  components: {
    Scroll: __WEBPACK_IMPORTED_MODULE_1_base_scroll_scroll___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_2_base_loading_loading___default.a,
    NoResult: __WEBPACK_IMPORTED_MODULE_3_base_no_result_no_result___default.a
  }
});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 481:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 492:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 496:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(534),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-429160fb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(489)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(538),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a1ec93d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(487)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(536),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ccad3a3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(480)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(529),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-213c2fc0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(488)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(537),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56a58140",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(483)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(532),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3015abc0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(479)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(528),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-007bfa40",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(492)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(541),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6919f4cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 528:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "list-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    staticClass: "playlist",
    on: {
      "click": _vm.hide
    }
  }, [_c('div', {
    staticClass: "list-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "list-header"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "icon",
    class: _vm.iconMode,
    on: {
      "click": _vm.changeMode
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.modeText))]), _vm._v(" "), _c('span', {
    staticClass: "clear",
    on: {
      "click": _vm.showConfirm
    }
  }, [_c('i', {
    staticClass: "icon-clear"
  })])])]), _vm._v(" "), _c('scroll', {
    ref: "listContent",
    staticClass: "list-content",
    attrs: {
      "data": _vm.sequenceList,
      "refreshDelay": _vm.refreshDelay
    }
  }, [_c('transition-group', {
    ref: "list",
    attrs: {
      "name": "list",
      "tag": "ul"
    }
  }, _vm._l((_vm.sequenceList), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.selectItem(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "current",
      class: _vm.getCurrentIcon(item)
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "like",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleFavorite(item)
        }
      }
    }, [_c('i', {
      class: _vm.getFavoriteIcon(item)
    })]), _vm._v(" "), _c('span', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteOne(item)
        }
      }
    }, [_c('i', {
      staticClass: "icon-delete"
    })])])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "list-operate"
  }, [_c('div', {
    staticClass: "add",
    on: {
      "click": _vm.addSong
    }
  }, [_c('i', {
    staticClass: "icon-add"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("添加歌曲到队列")])])]), _vm._v(" "), _c('div', {
    staticClass: "list-close",
    on: {
      "click": _vm.hide
    }
  }, [_c('span', [_vm._v("关闭")])])], 1), _vm._v(" "), _c('confirm', {
    ref: "confirm",
    attrs: {
      "text": "是否清空播放列表",
      "confirmBtnText": "清空"
    },
    on: {
      "confirm": _vm.confirmClear
    }
  }), _vm._v(" "), _c('add-song', {
    ref: "addSong"
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 529:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    staticClass: "add-song",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("添加歌曲到列表")]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.hide
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "search-box-wrapper"
  }, [_c('search-box', {
    ref: "searchBox",
    attrs: {
      "placeholder": "搜索歌曲"
    },
    on: {
      "query": _vm.onQueryChange
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.query),
      expression: "!query"
    }],
    staticClass: "shortcut"
  }, [_c('switches', {
    attrs: {
      "switches": _vm.switches,
      "currentIndex": _vm.currentIndex
    },
    on: {
      "switch": _vm.switchItem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "list-wrapper"
  }, [(_vm.currentIndex === 0) ? _c('scroll', {
    ref: "songList",
    staticClass: "list-scroll",
    attrs: {
      "data": _vm.playHistory
    }
  }, [_c('div', {
    staticClass: "list-inner"
  }, [_c('song-list', {
    attrs: {
      "songs": _vm.playHistory
    },
    on: {
      "select": _vm.selectSong
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentIndex === 1) ? _c('scroll', {
    ref: "searchList",
    staticClass: "list-scroll",
    attrs: {
      "refreshDelay": _vm.refreshDelay,
      "data": _vm.searchHistory
    }
  }, [_c('div', {
    staticClass: "list-inner"
  }, [_c('search-list', {
    attrs: {
      "searches": _vm.searchHistory
    },
    on: {
      "delete": _vm.deleteSearchHistory,
      "select": _vm.addQuery
    }
  })], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "search-result"
  }, [_c('suggest', {
    attrs: {
      "query": _vm.query,
      "showSinger": _vm.showSinger
    },
    on: {
      "select": _vm.selectSuggest,
      "listScroll": _vm.blurInput
    }
  })], 1), _vm._v(" "), _c('top-tip', {
    ref: "topTip"
  }, [_c('div', {
    staticClass: "tip-title"
  }, [_c('i', {
    staticClass: "icon-ok"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("1首歌曲已经添加到播放列表")])])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 530:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "song-list"
  }, [_c('ul', _vm._l((_vm.songs), function(song, index) {
    return _c('li', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.selectItem(song, index)
        }
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rank),
        expression: "rank"
      }],
      staticClass: "rank"
    }, [_c('span', {
      class: _vm.getRankCls(index),
      domProps: {
        "textContent": _vm._s(_vm.getRankText(index))
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('h2', {
      staticClass: "name"
    }, [_vm._v(_vm._s(song.name))]), _vm._v(" "), _c('p', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(_vm.getDesc(song)))])])])
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ 531:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-result"
  }, [_c('div', {
    staticClass: "no-result-icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "no-result-text"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}

/***/ }),

/***/ 532:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playlist.length > 0),
      expression: "playlist.length>0"
    }],
    staticClass: "player"
  }, [_c('transition', {
    attrs: {
      "name": "normal"
    },
    on: {
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "leave": _vm.leave,
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fullScreen),
      expression: "fullScreen"
    }],
    staticClass: "normal-player"
  }, [_c('div', {
    staticClass: "background"
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": _vm.currentSong.image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "icon-back"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.name)
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.singer)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "middle",
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        return _vm.middleTouchStart($event)
      },
      "touchmove": function($event) {
        $event.preventDefault();
        return _vm.middleTouchMove($event)
      },
      "touchend": _vm.middleTouchEnd
    }
  }, [_c('div', {
    ref: "middleL",
    staticClass: "middle-l"
  }, [_c('div', {
    ref: "cdWrapper",
    staticClass: "cd-wrapper"
  }, [_c('div', {
    staticClass: "cd",
    class: _vm.cdCls
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.currentSong.image
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "playing-lyric-wrapper"
  }, [_c('div', {
    staticClass: "playing-lyric"
  }, [_vm._v(_vm._s(_vm.playingLyric))])])]), _vm._v(" "), _c('scroll', {
    ref: "lyricList",
    staticClass: "middle-r",
    attrs: {
      "data": _vm.currentLyric && _vm.currentLyric.lines
    }
  }, [_c('div', {
    staticClass: "lyric-wrapper"
  }, [(_vm.currentLyric) ? _c('div', _vm._l((_vm.currentLyric.lines), function(line, index) {
    return _c('p', {
      ref: "lyricLine",
      refInFor: true,
      staticClass: "text",
      class: {
        'current': _vm.currentLineNum === index
      }
    }, [_vm._v(_vm._s(line.txt))])
  }), 0) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "dot-wrapper"
  }, [_c('span', {
    staticClass: "dot",
    class: {
      'active': _vm.currentShow === 'cd'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dot",
    class: {
      'active': _vm.currentShow === 'lyric'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "progress-wrapper"
  }, [_c('span', {
    staticClass: "time time-l"
  }, [_vm._v(_vm._s(_vm.format(_vm.currentTime)))]), _vm._v(" "), _c('div', {
    staticClass: "progress-bar-wrapper"
  }, [_c('progress-bar', {
    attrs: {
      "percent": _vm.percent
    },
    on: {
      "percentChange": _vm.onProgressBarChange
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "time time-r"
  }, [_vm._v(_vm._s(_vm.format(_vm.currentSong.duration)))])]), _vm._v(" "), _c('div', {
    staticClass: "operators"
  }, [_c('div', {
    staticClass: "icon i-left",
    on: {
      "click": _vm.changeMode
    }
  }, [_c('i', {
    class: _vm.iconMode
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-left",
    class: _vm.disableCls
  }, [_c('i', {
    staticClass: "icon-prev",
    on: {
      "click": _vm.prev
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-center",
    class: _vm.disableCls
  }, [_c('i', {
    class: _vm.playIcon,
    on: {
      "click": _vm.togglePlaying
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-right",
    class: _vm.disableCls
  }, [_c('i', {
    staticClass: "icon-next",
    on: {
      "click": _vm.next
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-right"
  }, [_c('i', {
    staticClass: "icon",
    class: _vm.getFavoriteIcon(_vm.currentSong),
    on: {
      "click": function($event) {
        _vm.toggleFavorite(_vm.currentSong)
      }
    }
  })])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "mini"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullScreen),
      expression: "!fullScreen"
    }],
    staticClass: "mini-player",
    on: {
      "click": _vm.open
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    class: _vm.cdCls,
    attrs: {
      "width": "40",
      "height": "40",
      "src": _vm.currentSong.image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h2', {
    staticClass: "name",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.name)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.singer)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('progress-circle', {
    attrs: {
      "radius": _vm.radius,
      "percent": _vm.percent
    }
  }, [_c('i', {
    staticClass: "icon-mini",
    class: _vm.miniIcon,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.togglePlaying($event)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "control",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showPlaylist($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-playlist"
  })])])]), _vm._v(" "), _c('playlist', {
    ref: "playlist"
  }), _vm._v(" "), _c('audio', {
    ref: "audio",
    attrs: {
      "src": _vm.currentSong.url
    },
    on: {
      "play": _vm.ready,
      "error": _vm.error,
      "timeupdate": _vm.updateTime,
      "ended": _vm.end
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 533:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searches.length),
      expression: "searches.length"
    }],
    staticClass: "search-list"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "ul"
    }
  }, _vm._l((_vm.searches), function(item) {
    return _c('li', {
      key: item,
      staticClass: "search-item",
      on: {
        "click": function($event) {
          _vm.selectItem(item)
        }
      }
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('span', {
      staticClass: "icon",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteOne(item)
        }
      }
    }, [_c('i', {
      staticClass: "icon-delete"
    })])])
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "progressBar",
    staticClass: "progress-bar",
    on: {
      "click": _vm.progressClick
    }
  }, [_c('div', {
    staticClass: "bar-inner"
  }, [_c('div', {
    ref: "progress",
    staticClass: "progress"
  }), _vm._v(" "), _c('div', {
    ref: "progressBtn",
    staticClass: "progress-btn-wrapper",
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        return _vm.progressTouchStart($event)
      },
      "touchmove": function($event) {
        $event.preventDefault();
        return _vm.progressTouchMove($event)
      },
      "touchend": _vm.progressTouchEnd
    }
  }, [_c('div', {
    staticClass: "progress-btn"
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-box"
  }, [_c('i', {
    staticClass: "icon-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    ref: "query",
    staticClass: "box",
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "icon-dismiss",
    on: {
      "click": _vm.clear
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "drop"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    staticClass: "top-tip",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hide($event)
      }
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 537:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-header"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('h1', {
    staticClass: "text"
  }, [_vm._v("Chicken Music")]), _vm._v(" "), _c('router-link', {
    staticClass: "mine",
    attrs: {
      "tag": "div",
      "to": "/user"
    }
  }, [_c('i', {
    staticClass: "icon-mine"
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 538:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-circle"
  }, [_c('svg', {
    attrs: {
      "width": _vm.radius,
      "height": _vm.radius,
      "viewBox": "0 0 100 100",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    staticClass: "progress-background",
    attrs: {
      "r": "50",
      "cx": "50",
      "cy": "50",
      "fill": "transparent"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "progress-bar",
    attrs: {
      "r": "50",
      "cx": "50",
      "cy": "50",
      "fill": "transparent",
      "stroke-dasharray": _vm.dashArray,
      "stroke-dashoffset": _vm.dashOffset
    }
  })]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('scroll', {
    ref: "suggest",
    staticClass: "suggest",
    attrs: {
      "data": _vm.result,
      "pullup": _vm.pullup,
      "beforeScroll": _vm.beforeScroll
    },
    on: {
      "scrollToEnd": _vm.searchMore,
      "beforeScroll": _vm.listScroll
    }
  }, [_c('ul', {
    staticClass: "suggest-list"
  }, [_vm._l((_vm.result), function(item) {
    return _c('li', {
      staticClass: "suggest-item",
      on: {
        "click": function($event) {
          _vm.selectItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('i', {
      class: _vm.getIconCls(item)
    })]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_c('p', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.getDisplayName(item))
      }
    })])])
  }), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasMore),
      expression: "hasMore"
    }],
    attrs: {
      "title": ""
    }
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasMore && !_vm.result.length),
      expression: "!hasMore && !result.length"
    }],
    staticClass: "no-result-wrapper"
  }, [_c('no-result', {
    attrs: {
      "title": "抱歉，暂无搜索结果"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "confirm-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    staticClass: "confirm",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "confirm-wrapper"
  }, [_c('div', {
    staticClass: "confirm-content"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', {
    staticClass: "operate-btn left",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelBtnText))]), _vm._v(" "), _c('div', {
    staticClass: "operate-btn",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.confirmBtnText))])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab"
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "tag": "div",
      "to": "/recommend"
    }
  }, [_c('span', {
    staticClass: "tab-link"
  }, [_vm._v("推荐")])]), _vm._v(" "), _c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "tag": "div",
      "to": "/singer"
    }
  }, [_c('span', {
    staticClass: "tab-link"
  }, [_vm._v("歌手")])]), _vm._v(" "), _c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "tag": "div",
      "to": "/rank"
    }
  }, [_c('span', {
    staticClass: "tab-link"
  }, [_vm._v("排行")])]), _vm._v(" "), _c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "tag": "div",
      "to": "/search"
    }
  }, [_c('span', {
    staticClass: "tab-link"
  }, [_vm._v("搜索")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('m-header'), _vm._v(" "), _c('tab'), _vm._v(" "), _c('keep-alive', [_c('router-view')], 1), _vm._v(" "), _c('player')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "switches"
  }, _vm._l((_vm.switches), function(item, index) {
    return _c('li', {
      staticClass: "switch-item",
      class: {
        'active': _vm.currentIndex === index
      },
      on: {
        "click": function($event) {
          _vm.switchItem(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name) + " ")])])
  }), 0)
},staticRenderFns: []}

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "width": "24",
      "height": "24",
      "src": __webpack_require__(519)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return playMode; });
var playMode = {
  sequence: 0,
  loop: 1,
  random: 2
};

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(495)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(544),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c46eaa8a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return playlistMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return playerMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_js_config__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_js_util__ = __webpack_require__(88);





var playlistMixin = {
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['playlist'])),
  mounted: function mounted() {
    this.handlePlaylist(this.playlist);
  },
  activated: function activated() {
    this.handlePlaylist(this.playlist);
  },

  watch: {
    playlist: function playlist(newVal) {
      this.handlePlaylist(newVal);
    }
  },
  methods: {
    handlePlaylist: function handlePlaylist() {
      throw new Error('component must implement handlePlaylist method');
    }
  }
};

var playerMixin = {
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    iconMode: function iconMode() {
      return this.mode === __WEBPACK_IMPORTED_MODULE_2_common_js_config__["a" /* playMode */].sequence ? 'icon-sequence' : this.mode === __WEBPACK_IMPORTED_MODULE_2_common_js_config__["a" /* playMode */].loop ? 'icon-loop' : 'icon-random';
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['sequenceList', 'playlist', 'currentSong', 'mode', 'favoriteList'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    changeMode: function changeMode() {
      var mode = (this.mode + 1) % 3;
      this.setPlayMode(mode);
      var list = null;
      if (mode === __WEBPACK_IMPORTED_MODULE_2_common_js_config__["a" /* playMode */].random) {
        list = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_common_js_util__["a" /* shuffle */])(this.sequenceList);
      } else {
        list = this.sequenceList;
      }
      this.resetCurrentIndex(list);
      this.setPlaylist(list);
    },
    resetCurrentIndex: function resetCurrentIndex(list) {
      var _this = this;

      var index = list.findIndex(function (item) {
        return item.id === _this.currentSong.id;
      });
      this.setCurrentIndex(index);
    },
    toggleFavorite: function toggleFavorite(song) {
      if (this.isFavorite(song)) {
        this.deleteFavoriteList(song);
      } else {
        this.saveFavoriteList(song);
      }
    },
    getFavoriteIcon: function getFavoriteIcon(song) {
      if (this.isFavorite(song)) {
        return 'icon-favorite';
      }
      return 'icon-not-favorite';
    },
    isFavorite: function isFavorite(song) {
      var index = this.favoriteList.findIndex(function (item) {
        return item.id === song.id;
      });
      return index > -1;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])({
    setPlayMode: 'SET_PLAY_MODE',
    setPlaylist: 'SET_PLAYLIST',
    setCurrentIndex: 'SET_CURRENT_INDEX',
    setPlayingState: 'SET_PLAYING_STATE'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['saveFavoriteList', 'deleteFavoriteList']))
};

var searchMixin = {
  data: function data() {
    return {
      query: '',
      refreshDelay: 120
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['searchHistory'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    onQueryChange: function onQueryChange(query) {
      this.query = query;
    },
    blurInput: function blurInput() {
      this.$refs.searchBox.blur();
    },
    addQuery: function addQuery(query) {
      this.$refs.searchBox.setQuery(query);
    },
    saveSearch: function saveSearch() {
      this.saveSearchHistory(this.query);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['saveSearchHistory', 'deleteSearchHistory']))
};

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shuffle;
/* harmony export (immutable) */ __webpack_exports__["b"] = debounce;
function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

function shuffle(arr) {
  var _arr = arr.slice();
  for (var i = 0; i < _arr.length; i++) {
    var j = getRandomInt(0, i);
    var t = _arr[i];
    _arr[i] = _arr[j];
    _arr[j] = t;
  }
  return _arr;
}

function debounce(func, delay) {
  var timer = void 0;

  return function () {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      func.apply(_this, args);
    }, delay);
  };
}

/***/ })

},[209]);


// WEBPACK FOOTER //
// static/js/app.da5f813b777831583b32.js